import * as React from 'react';
import {NewIcalFeed} from '../types'
import {List, Map } from 'immutable'


declare var I18n : {
  locale: string,
  t: (_:string, __?: any) => string,
  toCurrency:(_:number) => string
}

export type AddFeedFormProps = {
  addFeed:(_:NewIcalFeed, __: () => void) => void
  creating:boolean
  errors:Map<string, List<string>>
};

export type AddFeedFormState = {
  feed:NewIcalFeed
};

class AddFeedForm extends React.Component<AddFeedFormProps, AddFeedFormState> {

  constructor(props:AddFeedFormProps) {
    super(props);
    this.state = {
      feed: { name: "", url: "" }
    }
  }

  addFeed = (e:React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();
    this.props.addFeed(this.state.feed, () => this.setState({feed: {name: "", url: ""}}));
  }

  updateFeed(feed:NewIcalFeed) {
    this.setState({...this.state, feed: feed})
  }

  renderErrorsFor(field:string) : JSX.Element{
    if (!this.props.errors) {
      return null
    }

    if (!this.props.errors.has(field)) {
      return null;
    }

    var fieldErrors = this.props.errors.get(field);
    return <div className="error-message">{fieldErrors.join(', ')}</div>
  }

  public render(): JSX.Element {
    const { feed } = this.state;

    return (
      <div className="Ical__info">
        <div className="Ical__name">
          <label className="Ical__label-name" htmlFor="name">
            {I18n.t("activerecord.attributes.calendar_feed.name")}
          </label>
          <input
            className="Ical__input-name"
            id="name"
            type="text"
            value={this.state.feed.name}
            disabled={this.props.creating}
            onChange={(e) => {
              this.updateFeed({...feed, name: e.currentTarget.value})
            }}
          />
          {this.renderErrorsFor('name')}

        </div>
        <div className="Ical__url">
          <label className="Ical__label-url" htmlFor="url">
          {I18n.t("activerecord.attributes.calendar_feed.url")}
          </label>
          <input
            className="Ical__input-url"
            id="url"
            type="text"
            value={this.state.feed.url}
            disabled={this.props.creating}
            onChange={(e) => {
              this.updateFeed({...feed, url: e.currentTarget.value})
            }}
          />
          {this.renderErrorsFor('url')}
        </div>
        <input
          className="btn btn--primary"
          type="button"
          value={this.props.creating ? I18n.t("calendar_feeds.crud.add.working") : I18n.t("calendar_feeds.crud.add.button")}
          disabled={this.props.creating}
          onClick={this.addFeed}
        />
      </div>
    );
  }
}

export default AddFeedForm;
